;(() => {
    const menu = document.querySelector('.js-nav'), 
          btnMenu = document.querySelector('.js-btn--collapse'),
          brand = menu.querySelector('.c-nav__brand img'),
          menuCollapse = menu.querySelector('.c-nav__collapse');

    window.addEventListener('scroll', (scrollEvent) => {
        if ( window.scrollY > 0 ) {
            menu.classList.add('is-active');
            brand.src = 'img/travessia.svg';
        } else {
            menu.classList.remove('is-active');
            brand.src = 'img/travessia-n.svg';
        }
    });

    menu.addEventListener('click', function(clickEvent) {
        if ( clickEvent.target.hasAttribute('href') ) {
            btnMenu.click();
        }
    });

    btnMenu.addEventListener('click', (clickEvent) => {
        btnMenu.classList.toggle('is-active');

        if ( menuCollapse.classList.contains('is-hidden') ) {
            menuCollapse.classList.remove('is-hidden');
            menuCollapse.classList.add('is-openned');
        } else {
            menuCollapse.classList.remove('is-openned');
            menuCollapse.offsetWidth;
            menuCollapse.classList.add('is-hidding');
        }

        menuCollapse.addEventListener('animationend', () => {
            if( menuCollapse.classList.contains('is-hidding') ) {
                menuCollapse.classList.remove('is-hidding');
                menuCollapse.classList.add('is-hidden');
            }
        });
    });
})()